import {Component, Input, Output, EventEmitter, ViewChild, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {Observable} from "rxjs";
import {MicroSelectComponent} from "../shared/select/micro-select.component";

@Component({
  selector: 'micro-rating-select',
  templateUrl: './rating-select.component.html'
})
export class RatingSelectComponent implements OnInit {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Input()
  mode:string = 'simple';

  @Output()
  ratingIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  ratingId:any;

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  unit:any;

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  relevant:boolean = false;

  @Input()
  jump:boolean = true;

  options:any[];

  change(e) {
    this.ratingIdChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  reload() {
    let params:HttpParams = new HttpParams();
    if (this.unit && this.unit !== '') {
      params = params.set('unit', this.unit);
    }
    this.sel.loading = true;
    return this.http.get(`${this.env.e.url}/pay/ratings/${this.relevant ? 'relevant' : 'all'}`, {params:params})
      .subscribe(data => {
        this.options = data as any[];
        this.sel.loading = false;
      });
  }

  ngOnInit(): void {
    this.reload();
  }
}
